import { Box } from '@hopskipdrive/react-components';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const BannerContainer = styled(Box)`
  background-color: ${colorTokens.primary.dark};
  border-radius: 4px;
  padding: 6px 16px 6px 30px;
  margin-bottom: 24px;
  display: flex;
  align-items: flex-start;
`;

export const TextColumn = styled(Box)`
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
  min-width: 0;
`;

export const BannerTitle = styled.h3`
  color: ${colorTokens.text.contrast};
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.15px;
  margin: 0;
`;

export const BannerDescription = styled.p`
  color: ${colorTokens.text.contrast};
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.1px;
  margin: 0;
`;

export const SearchContainer = styled(Box)`
  display: flex;
  gap: 15px;
  align-items: flex-start;
  padding: 9px 0;
`;

export const CloseButtonContainer = styled(Box)`
  display: flex;
  align-items: flex-start;
  padding: 2px 0 2px 16px;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  height: 42px;
  padding: 5px 9px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.8;
  }
`;
